/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { GalleryContext } from "../context/gallery-context";
import { ImageCard } from "./image-card";
import { ImageSelectedBadge } from "./image-selected-badge";
import { MODES } from "cms/images/image-selector/image-selector-config";


const SelectGalleryItem = (props) => {

    const { image, isSelected } = props;
    const {
        setSelectedImage,
        setMode,
        onSelectImage,
    } = useContext(GalleryContext);

    const selectImage = (e, image) => {
        e.stopPropagation();
        onSelectImage(e, image);
        setMode(MODES.SELECT_PREVIEW);
        setSelectedImage(image);
    };

    return (
        <>
            <div style={{
                display: "flex", flexDirection: "column", alignItems: "center",
                // width: '100%',
                // paddingRight: '4px', paddingLeft: '4px'
            }}
            >
                <ImageCard
                    image={image}
                    selectImage={selectImage}
                >
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", width: "100%" }}>
                        {isSelected &&
                            <ImageSelectedBadge color='#00685E' />
                        }
                    </div>
                </ImageCard>
            </div>
        </>
    );
};
export default SelectGalleryItem;
